import { ADMIN_PATHS } from '../adminPaths';

const R = ADMIN_PATHS.REPORTS;

/** Chemins des 4 domaines de rapports admin. */
export const ADMIN_REPORT_PATHS = {
  ROOT: R,
  RECEPTION: `${R}/reception`,
  RECEPTION_PASSAGES: `${R}/reception/passages`,
  RECEPTION_RDV: `${R}/reception/rendez-vous`,
  CLINIQUE: `${R}/clinique`,
  CLINIQUE_SYNTHESE: `${R}/clinique/synthese`,
  CLINIQUE_CONSULTATIONS: `${R}/clinique/consultations`,
  CLINIQUE_REPOS: `${R}/clinique/jours-repos`,
  CLINIQUE_MORBIDITE: `${R}/clinique/morbidite`,
  CLINIQUE_PATHOLOGIES: `${R}/clinique/pathologies`,
  CLINIQUE_ORDONNANCES: `${R}/clinique/ordonnances`,
  CLINIQUE_MEDICAMENTS: `${R}/clinique/medicaments`,
  CLINIQUE_EXAMENS: `${R}/clinique/examens`,
  CLINIQUE_AT: `${R}/clinique/accidents-travail`,
  CLINIQUE_MP: `${R}/clinique/maladies-professionnelles`,
  INFIRMERIE: `${R}/infirmerie`,
  INFIRMERIE_SOINS: `${R}/infirmerie/soins`,
  INFIRMERIE_INJECTIONS: `${R}/infirmerie/injections`,
  INFIRMERIE_TESTS: `${R}/infirmerie/tests`,
  INFIRMERIE_VACCINS: `${R}/infirmerie/vaccins`,
  INFIRMERIE_PF: `${R}/infirmerie/planning-familial`,
  PHARMACIE: `${R}/pharmacie`
};

/** @deprecated alias — chemins cliniques + infirmerie */
export const ADMIN_ANALYTICS_PATHS = {
  ROOT: ADMIN_REPORT_PATHS.ROOT,
  SYNTHESE: ADMIN_REPORT_PATHS.CLINIQUE_SYNTHESE,
  CONSULTATIONS: ADMIN_REPORT_PATHS.CLINIQUE_CONSULTATIONS,
  REPOS: ADMIN_REPORT_PATHS.CLINIQUE_REPOS,
  MORBIDITE: ADMIN_REPORT_PATHS.CLINIQUE_MORBIDITE,
  PATHOLOGIES: ADMIN_REPORT_PATHS.CLINIQUE_PATHOLOGIES,
  ORDONNANCES: ADMIN_REPORT_PATHS.CLINIQUE_ORDONNANCES,
  MEDICAMENTS: ADMIN_REPORT_PATHS.CLINIQUE_MEDICAMENTS,
  SOINS: ADMIN_REPORT_PATHS.INFIRMERIE,
  EXAMENS: ADMIN_REPORT_PATHS.CLINIQUE_EXAMENS,
  AT: ADMIN_REPORT_PATHS.CLINIQUE_AT,
  MP: ADMIN_REPORT_PATHS.CLINIQUE_MP,
  NURSING_ROOT: ADMIN_REPORT_PATHS.INFIRMERIE,
  NURSING_SOINS: ADMIN_REPORT_PATHS.INFIRMERIE_SOINS,
  NURSING_INJECTIONS: ADMIN_REPORT_PATHS.INFIRMERIE_INJECTIONS,
  NURSING_TESTS: ADMIN_REPORT_PATHS.INFIRMERIE_TESTS,
  NURSING_VACCINS: ADMIN_REPORT_PATHS.INFIRMERIE_VACCINS,
  NURSING_PF: ADMIN_REPORT_PATHS.INFIRMERIE_PF
};

/** Clés compatibles HEAD_DOCTOR_PATHS (liens synthèse → restent sous clinique / infirmerie). */
export const ADMIN_CLINICAL_REPORT_PATHS = {
  STATISTIQUES_SYNTHESE: ADMIN_REPORT_PATHS.CLINIQUE_SYNTHESE,
  STATISTIQUES_CONSULTATIONS: ADMIN_REPORT_PATHS.CLINIQUE_CONSULTATIONS,
  STATISTIQUES_JOURS_REPOS: ADMIN_REPORT_PATHS.CLINIQUE_REPOS,
  STATISTIQUES_MORBIDITE: ADMIN_REPORT_PATHS.CLINIQUE_MORBIDITE,
  STATISTIQUES_PATHOLOGIES: ADMIN_REPORT_PATHS.CLINIQUE_PATHOLOGIES,
  STATISTIQUES_ORDONNANCES: ADMIN_REPORT_PATHS.CLINIQUE_ORDONNANCES,
  STATISTIQUES_MEDICAMENTS: ADMIN_REPORT_PATHS.CLINIQUE_MEDICAMENTS,
  STATISTIQUES_SOINS: ADMIN_REPORT_PATHS.INFIRMERIE,
  STATISTIQUES_EXAMENS: ADMIN_REPORT_PATHS.CLINIQUE_EXAMENS,
  STATISTIQUES_WORK_ACCIDENTS: ADMIN_REPORT_PATHS.CLINIQUE_AT,
  STATISTIQUES_OCCUPATIONAL_DISEASES: ADMIN_REPORT_PATHS.CLINIQUE_MP
};

export const SERVICE_LINE_OPTIONS = [
  { value: '', label: 'Toutes les filières' },
  { value: 'MEDICAL', label: 'Médicale' },
  { value: 'DENTAL', label: 'Dentaire' },
  { value: 'NURSING', label: 'Infirmerie' }
];
